import { useState } from 'react';

export const usePopoverControls = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const openPopover = (e: any) => setAnchorEl(e.target);
  const closePopover = () => setAnchorEl(null);

  return { anchorEl, openPopover, closePopover };
};
